import { render, staticRenderFns } from "./SelectLocationInventory.vue?vue&type=template&id=9af1c5a4&"
import script from "./SelectLocationInventory.vue?vue&type=script&lang=ts&"
export * from "./SelectLocationInventory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9af1c5a4')) {
      api.createRecord('9af1c5a4', component.options)
    } else {
      api.reload('9af1c5a4', component.options)
    }
    module.hot.accept("./SelectLocationInventory.vue?vue&type=template&id=9af1c5a4&", function () {
      api.rerender('9af1c5a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SalesOrder/SelectLocationInventory.vue"
export default component.exports